<template>
    <div class="news">
        <div class="news-tab-top">
            <div class="news-tab__content-container">
                <h2 class="news-tab__content-heading" v-html=articleOneHeadline></h2>

                <div class="news-tab__read-more-link-container">
                    <a v-if="articleOneLinkType === 'link'" class="news-tab__read-more-link" :href=articleOneLink target="_blank">Read More</a>
                    <router-link v-else class="news-tab__read-more-link" :to=articleOneLink>Read More</router-link>
                </div>
            </div>

            <transition appear
                v-on:before-enter="beforeEnterImageTab"
                v-on:enter="enterImageTab">
                <div class="news-tab-top__image-container">
                    <img :src=articleOneImage :alt=articleOneImageAltText class="news-tab-top__image">
                </div>
            </transition>
        </div>

        <div class="news-tab-bottom">
            <div class="news-tab__content-container">
                <h2 class="news-tab__content-heading" v-html=articleTwoHeadline></h2>

                <div class="news-tab__read-more-link-container">
                    <a v-if="articleTwoLinkType === 'link'" class="news-tab__read-more-link" :href=articleTwoLink target="_blank">Read More</a>
                    <router-link v-else class="news-tab__read-more-link" :to=articleTwoLink>Read More</router-link>
                </div>
            </div>

            <transition appear
                v-on:before-enter="beforeEnterImageTab"
                v-on:enter="enterImageTab">
                <div class="news-tab-bottom__image-container">
                    <img :src=articleTwoImage :alt=articleTwoImageAltText class="news-tab-bottom__image">
                </div>
            </transition>
        </div>

        <transition appear
                v-on:before-enter="beforeEnterWorkContent"
                v-on:enter="enterWorkContent">
            <div class="news-content__container">
                <h2 class="news-content__heading">NEWS</h2>

                <ul class="news-content__page-counter-list">
                    <li class="news-content__page-counter-item">
                        <router-link class="news-content__page-counter-link" to="/work"></router-link>
                    </li>

                    <li class="news-content__page-counter-item">
                        <router-link class="news-content__page-counter-link" to="/culture"></router-link>
                    </li>

                    <li class="news-content__page-counter-item">
                        <router-link class="news-content__page-counter-link" to="/expertise"></router-link>
                    </li>

                    <li class="news-content__page-counter-item">
                        <router-link class="news-content__page-counter-link active" to="/news"></router-link>
                    </li>

                    <li class="news-content__page-counter-item">
                        <router-link class="news-content__page-counter-link" to="/contact"></router-link>
                    </li>
                </ul>

                <button class="news-content__cta" v-on:click="exploreClick">Explore</button>
            </div>
        </transition>

        <transition appear
                v-on:before-enter="beforeEnterSideNavLeft"
                v-on:enter="enterSideNavLeft">
            <div class="news-side-nav__container--left">
                <router-link class="news-side-nav__link" to="/expertise">
                    <h2 class="news-side-nav__heading">Expertise</h2>

                    <ul class="news-side-nav__page-counter-list">
                        <li class="news-side-nav__page-counter-item "></li>

                        <li class="news-side-nav__page-counter-item"></li>

                        <li class="news-side-nav__page-counter-item active"></li>

                        <li class="news-side-nav__page-counter-item"></li>

                        <li class="news-side-nav__page-counter-item"></li>
                    </ul>
                </router-link>
            </div>
        </transition>

        <transition appear
                v-on:before-enter="beforeEnterSideNavRight"
                v-on:enter="enterSideNavRight">
            <div class="news-side-nav__container--right">
                <router-link class="news-side-nav__link" to="/contact">
                    <h2 class="news-side-nav__heading">Contact</h2>

                    <ul class="news-side-nav__page-counter-list">
                        <li class="news-side-nav__page-counter-item"></li>

                        <li class="news-side-nav__page-counter-item"></li>

                        <li class="news-side-nav__page-counter-item"></li>

                        <li class="news-side-nav__page-counter-item"></li>

                        <li class="news-side-nav__page-counter-item active"></li>
                    </ul>
                </router-link>
            </div>
        </transition>
    </div>
</template>

<style scoped lang="less">
    @import "../less/breakpoints.less";

    .news {
        background-color: #ffffff;
        color: #ffffff;
        height: 100vh;
        width: 100%;
        overflow: hidden;
        position: relative;
    }

    .news-content__container {
        left: 50%;
        position: absolute;
        text-align: center;
        top: 50%;
        transform: translate(-50%, -50%) scale(0.1);
        transform-origin: center center;
        transition: all 0.8s ease;
        z-index: 20;

        &.transform-anim {
            transform: translate(-50%, -50%) scale(1);
        }

        .news-content__heading {
            color: #003a4a;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 96px;
            letter-spacing: 1.5px;
            line-height: 1;
            margin: 0 0 20px;
            text-transform: uppercase;

            @media @breakpoint__tablet--large {
                font-size: 60px;
            }

            @media @breakpoint__mobile--large {
                font-size: 40px;
                margin: 0 0 10px;
            }
        }

        .news-content__cta {
            background-color: #e40046;
            border: none;
            border-radius: 5px;
            color: #fff;
            cursor: pointer;
            display: inline-block;
            font-size: 16px;
            letter-spacing: 1px;
            padding: 10px 30px;
            text-decoration: none;
            z-index: 20;

            @media @breakpoint__tablet--small {
                font-size: 14px;
            }
        }

        .news-content__page-counter-list {
            margin: 0 0 25px;
            padding: 0;

            .news-content__page-counter-item {
                display: inline-block;
                margin: 0 8px;

                @media @breakpoint__mobile--large {
                    border-radius: 2px;
                    height: 8px;
                    margin: 0 5px;
                    width: 8px;
                }

                .news-content__page-counter-link {
                    background: #cccccd;
                    border-radius: 3px;
                    display: block;
                    z-index: 1;
                    height: 12px;
                    width: 12px;

                    @media @breakpoint__mobile--large {
                        border-radius: 2px;
                        height: 8px;
                        width: 8px;
                    }

                    &.active {
                        background: #e40046;
                    }
                }
            }
        }
    }

    .news-tab__content-container {
        position: absolute;
        top: 50%;
        left: 50%;
        opacity: 0;
        text-align: center;
        transform: translate(-50%, -30%);
        width: 80%;
        z-index: 100;

        .news-tab__content-heading {
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 26px;
            margin: 0 0 30px;
            padding-bottom: 20px;
            position: relative;

            @media @breakpoint__mobile--large {
                font-size: 14px;
                margin: 0px 0 15px;
                padding-bottom: 15px;
            }

            &:after {
                bottom: 0;
                content: "";
                border-bottom: 2px solid red;
                position: absolute;
                left: 50%;
                width: 150px;
                transform: translateX(-50%);
            }
        }

        .news-tab__read-more-link {
            border: 1px solid #ffffff;
            border-radius: 5px;
            color: #ffffff;
            cursor: pointer;
            display: inline-block;
            font-family: Flama, Arial, Helvetica, sans-serif;
            font-size: 18px;
            letter-spacing: 0.2px;
            line-height: 1;
            margin: 0;
            padding: 3px 6px 2px;
            text-decoration: none;
            text-transform: uppercase;
            transition: 0.5s all;

            @media @breakpoint__mobile--large {
                font-size: 12px;
                line-height: 1.4;
                padding: 0 5px 1px;
            }

            &:focus {
                outline: none;
            }

            &:hover {
                background: #ffffff;
                color: #003a4a;
            }
        }
    }

    .news-tab-top {
        -webkit-mask-image: -webkit-radial-gradient(white, black);
        background: url(/assets/imgs/tab-pattern-bg.png);
        border-radius: 0 0 150px 150px;
        max-height: 32%;
        left: 0;
        margin: 0 auto;
        max-width: 830px;
        overflow: hidden;
        position: absolute;
        right: 0;

        .news-tab-top__image-container {
            -webkit-mask-image: -webkit-radial-gradient(white, black);
            border-radius: 0 0 150px 150px;
            display: block;
            margin: 0 auto;
            max-width: 830px;
            overflow: hidden;
            position: relative;
            transform: translateX(0);
            z-index: 10;

            .news-tab-top__image {
                display: block;
                width: 100%;
            }

            &:before {
                content: "";
                background-color: #003A4A;
                height: 100%;
                left: 0;
                opacity: 0;
                position: absolute;
                transition: 0.5s opacity;
                top: 0;
                width: 100%;
            }
            
            &.active {
                &:before {
                    opacity: 0.7;
                }
            }

            @media @breakpoint__tablet--medium {
                border-radius: 0 0 100px 100px;
            }

            @media @breakpoint__mobile--large {
                border-radius: 0 0 50px 50px;
            }
        }

        @media @breakpoint__tablet--medium {
            border-radius: 0 0 100px 100px;
        }

        @media @breakpoint__mobile--large {
            border-radius: 0 0 50px 50px;
        }
    }

    .news-tab-bottom {
        -webkit-mask-image: -webkit-radial-gradient(white, black);
        background: url(/assets/imgs/tab-pattern-bg.png);
        border-radius: 150px 150px 0 0;
        bottom: 0;
        max-height: 32%;
        left: 0;
        margin: 0 auto;
        max-width: 830px;
        overflow: hidden;
        position: absolute;
        right: 0;

        .news-tab-bottom__image-container {
            -webkit-mask-image: -webkit-radial-gradient(white, black);
            border-radius: 150px 150px 0 0;
            display: block;
            margin: 0 auto;
            max-width: 830px;
            overflow: hidden;
            position: relative;
            z-index: 10;

            .news-tab-bottom__image {
                display: block;
                width: 100%;
            }

            &:before {
                content: "";
                background-color: #003A4A;
                height: 100%;
                left: 0;
                opacity: 0;
                position: absolute;
                transition: 0.5s opacity;
                top: 0;
                width: 100%;
            }

            &.active {
                &:before {
                    opacity: 0.7;
                }
            }

            @media @breakpoint__tablet--medium {
                border-radius: 100px 100px 0 0;
            }

            @media @breakpoint__mobile--large {
                border-radius: 50px 50px 0 0;
            }
        }

        @media @breakpoint__tablet--medium {
            border-radius: 100px 100px 0 0;
        }

        @media @breakpoint__mobile--large {
            border-radius: 50px 50px 0 0;
        }
    }

    .news-side-nav__link {
        text-decoration: none;
    }

    .news-side-nav__container {
        position: absolute;
        text-align: right;
        top: 52%;
        transform: translate(0, -50%);
        z-index: 10;

        .news-side-nav__heading {
            color: #dfe6e8;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 28px;
            letter-spacing: 1.5px;
            line-height: 1;
            margin: 0;
            text-transform: uppercase;

            @media @breakpoint__tablet--small {
                font-size: 20px;
            }

            @media @breakpoint__mobile--large {
                font-size: 14px;
            }
        }

        .news-side-nav__page-counter-list {
            margin: 0;
            padding: 0;

            .news-side-nav__page-counter-item {
                background: #cccccd;
                border-radius: 1.5px;
                display: inline-block;
                height: 5px;
                margin: 0 3px;
                width: 5px;
                z-index: 1;

                &.active {
                    background: #e40046;
                }
            }
        }

         @media @breakpoint__mobile--large {
             display: none;
         }
    }

    .news-side-nav__container--left {
        .news-side-nav__container();
        left: 12px;
        text-align: left;
    }

    .news-side-nav__container--right {
        .news-side-nav__container();
        right: 12px;
    }
</style>

<script>
    export default {
        name: "News",
        data: function()
        {
            return {
                articleOneHeadline : "",
                articleOneParagraph : "",
                articleOneImage : "",
                articleOneImageAltText : "",
                articleOneLink : "",
                articleOneLinkType : "",
                articleTwoHeadline : "",
                articleTwoParagraph : "",
                articleTwoImage : "",
                articleTwoImageAltText : "",
                articleTwoLink : "",
                articleTwoLinkType : ""
            }
        },
        created : function()
        {
            var vm = this;
            var testIfDataLoaded = setInterval(function()
            {
                if (!vm.isObjectEmpty(vm.$parent.modelSeo))
                {
                    clearInterval(testIfDataLoaded);
                    vm.initImages(vm.$parent.modelNews);
                }
            }, 500);
        },
        mounted: function()
        {
            TweenMax.set(".header-nav-button", {className:"+=news-work"});
            TweenMax.to(".header__logo-sub-title-container", 0.2, {width: 0});
        },
        methods: {
            initImages : function(data)
            {
                this.articleOneHeadline = data[0].Headline;
                this.articleOneParagraph = data[0].ArticlePreview;
                this.articleOneImage = data[0].ArticleImageMain;
                this.articleOneImageAltText = data[0].ArticleImageAltText;
                this.articleOneLinkType = data[0].ArticleLinkType;

                if(this.articleOneLinkType === "link")
                {
                    this.articleOneLink = data[0].ArticleLink;
                }
                else
                {
                    this.articleOneLink = "/news/" + data[0].ArticleLink;
                }


                this.articleTwoHeadline = data[1].Headline;
                this.articleTwoParagraph = data[1].ArticlePreview;
                this.articleTwoImage = data[1].ArticleImageMain;
                this.articleTwoImageAltText = data[1].ArticleImageAltText;
                this.articleTwoLinkType = data[1].ArticleLinkType;

                if(this.articleTwoLinkType === "link")
                {
                    this.articleTwoLink = data[1].ArticleLink;
                }
                else
                {
                    this.articleTwoLink = "/news/" + data[1].ArticleLink;
                }
            },
            beforeEnterImageTab : function(el)
            {
                TweenMax.set(el, {opacity: 0});
                if (this.$parent._data.animationDirection === "right")
                {
                    TweenMax.set(el, {transform: "translateX(-150%)", delay: 0.1});
                }
                else
                {
                    TweenMax.set(el, {transform: "translateX(150%)", delay: 0.1});
                }
            },
            enterImageTab : function(el, done)
            {
                TweenMax.set(el, {opacity: 1, delay: 0.4});
                TweenMax.to(el, 0.7, {transform: "translateX(0)", delay: 0.4, onComplete: done});
            },
            beforeEnterWorkContent : function(el)
            {
                el.style.opacity = 0;

                if (this.$parent._data.animationDirection === "right")
                {
                    el.style.left = "10%";
                }
                else 
                {
                    el.style.left = "90%";
                }

                el.querySelector(".news-content__cta").style.transform = "scale(0, 0)";
            },
            enterWorkContent : function(el, done)
            {
                TweenMax.to(el, 0.3, {left: "50%", opacity: 1, delay: 0.3});
                TweenMax.set(el, {className:"+=transform-anim", delay: 0.6});
                TweenMax.to(".news-content__cta", 0.8, {transform: "scale(1, 1)", delay: 1.2, ease: Back.easeOut.config(2)});
                TweenMax.set(".news-tab-top__image-container", {className:"+=active", delay: 1.5});
                TweenMax.set(".news-tab-bottom__image-container", {className:"+=active", delay: 1.5});
                TweenMax.to(".news-tab__content-container", 0.5, {opacity: 1, delay: 1.7, onComplete: done});
            },
            goToExplore: function() {
                this.$router.push("/news/newswire");
            },
            beforeEnterSideNavLeft :function(el) {
                el.style.opacity = 0;
                el.style.transform = "translateX(-110%)";
            },
            enterSideNavLeft: function(el, done) {
                TweenMax.to(el, 0.5, {opacity: 1, transform : "translateX(0)", delay: 1.3});
            },
            beforeEnterSideNavRight :function(el) {
                el.style.opacity = 0;
                el.style.transform = "translateX(110%)";
            },
            enterSideNavRight : function(el, done) {
                TweenMax.to(el, 0.5, {opacity: 1, transform : "translateX(0)", delay: 1.3});
            },
            exploreClick: function()
            {
                TweenMax.to(document.querySelector(".news-content__container"), 0.3, {opacity: 0});
                TweenMax.to(document.querySelector(".news-tab-top"), 0.6, {transform: "translateY(-100%)", delay: 0.2, ease: Power4.easeIn});
                TweenMax.to(document.querySelector(".news-tab-bottom"), 0.6, {transform: "translateY(100%)", delay: 0.2, ease: Power4.easeIn});

                var vm = this;
                setTimeout(function() {vm.goToExplore()}, 1000);
            }
        }
    };
</script>
